import { FC, useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { GetSoilData } from "../../redux/actions/soilAction";
import { SoilData } from "../../Typings/dataListing";

interface SampleDetailsModalProps {
  isOpen: boolean;
  sample: any;
  onClose: () => void;
}

const SampleDetailsModal: FC<SampleDetailsModalProps> = ({
  isOpen,
  sample,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div 
        className="modal-dialog modal-dialog-centered modal-lg"
        style={{ maxHeight: '90vh' }} // Limit modal height to 90% of viewport height
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Sample Details</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div 
            className="modal-body"
            style={{
              maxHeight: 'calc(90vh - 120px)', // Subtract header and footer height
              overflowY: 'auto',
              overflowX: 'hidden'
            }}
          >
            <div className="table-responsive">
              <table className="table">
                <tbody>
                  <tr>
                    <td><strong>Lab Label</strong></td>
                    <td>{sample?.lablabel || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Farm ID</strong></td>
                    <td>{sample?.farmid || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>State</strong></td>
                    <td>{sample?.state || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Group Code</strong></td>
                    <td>{sample?.sgroupcode || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Test Code</strong></td>
                    <td>{sample?.testcode || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Long ID</strong></td>
                    <td>{sample?.longid || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Description</strong></td>
                    <td>{sample?.description || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Depth Class</strong></td>
                    <td>{sample?.depthclass || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Project Code</strong></td>
                    <td>{sample?.projectcode || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Sampling Date</strong></td>
                    <td>{sample?.sampling_date || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Received Date</strong></td>
                    <td>{sample?.received_date || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>BD (g/cm³)</strong></td>
                    <td>{sample?.bd_g_cm || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>pH</strong></td>
                    <td>{sample?.ph || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>µg CO2/g dry weight</strong></td>
                    <td>{sample?.ug_co2_g_dry_weight || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Sand %</strong></td>
                    <td>{sample?.sand_perc || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Clay %</strong></td>
                    <td>{sample?.clay_perc || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Silt %</strong></td>
                    <td>{sample?.silt_perc || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>TN (g/kg dry soil)</strong></td>
                    <td>{sample?.tn_g_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>SOC (g/kg dry soil)</strong></td>
                    <td>{sample?.soc_g_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>NH4 (mg/kg dry soil)</strong></td>
                    <td>{sample?.nh4_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>NO3 (mg/kg dry soil)</strong></td>
                    <td>{sample?.no3_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Al (mg/kg dry soil)</strong></td>
                    <td>{sample?.al_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Ca (mg/kg dry soil)</strong></td>
                    <td>{sample?.ca_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Cu (mg/kg dry soil)</strong></td>
                    <td>{sample?.cu_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Fe (mg/kg dry soil)</strong></td>
                    <td>{sample?.fe_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>K (mg/kg dry soil)</strong></td>
                    <td>{sample?.k_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Mg (mg/kg dry soil)</strong></td>
                    <td>{sample?.mg_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Mn (mg/kg dry soil)</strong></td>
                    <td>{sample?.mn_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Na (mg/kg dry soil)</strong></td>
                    <td>{sample?.na_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Ni (mg/kg dry soil)</strong></td>
                    <td>{sample?.ni_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>P (mg/kg dry soil)</strong></td>
                    <td>{sample?.p_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Pb (mg/kg dry soil)</strong></td>
                    <td>{sample?.pb_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>S (mg/kg dry soil)</strong></td>
                    <td>{sample?.s_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Zn (mg/kg dry soil)</strong></td>
                    <td>{sample?.zn_mg_kg_dry_soil || "-"}</td>
                  </tr>
                  <tr>
                    <td><strong>Notes</strong></td>
                    <td>{sample?.notes || "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const SoilView: FC = () => {
  const roleid = localStorage.getItem("roleid") ?? "";
  const { permissions, loading, error } = usePermissions();
  const dispatch = useDispatch<AppDispatch>();
  const { farm_id, treat_id, point_id } = useParams();
  const navigate = useNavigate();
  const [soilData, setSoilData] = useState<SoilData | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSample, setSelectedSample] = useState<any>(null);

  const handleOpenModal = (sample: any) => {
    setSelectedSample(sample);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedSample(null);
  };

  useEffect(() => {
    getSoilData();
  }, [dispatch]);

  const getSoilData = async () => {
    const payload = {
      farm_id: farm_id,
      treat_id: treat_id,
      point_id: point_id,
    };
    try {
      dispatch(
        GetSoilData(payload, (response: any) => {
          if (response?.data) {
            setSoilData({
              observations: response.data.observations || [],
              points: response.data.points || [],
              data_bd: response.data.data_bd || [],
              data_sample: response.data.data_sample || [],
            });
          }
        })
      );
    } catch (error) {
      console.error("Error fetching soil details:", error);
    }
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">Soil</span>
            </div>
          </div>
        </section>

        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              {/* Observations Section */}
              <li className="col-12">
                <span className="heading">SPCSP Field Observations</span>
              </li>
              {soilData?.observations.map((observation, index) => (
                <div
                  key={observation.globalid || index}
                  className="col-12 d-flex flex-wrap"
                >
                  <li className="col-6 col-md-4 col-lg-3">
                    Farm ID{" "}
                    <span className="d-block pt-1">
                      {observation.farm_id || "-"}
                    </span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Treatment ID{" "}
                    <span className="d-block pt-1">
                      {observation.treat_id || "-"}
                    </span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Treatment Name{" "}
                    <span className="d-block pt-1">
                      {observation.treatname || "-"}
                    </span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Site Notes{" "}
                    <span className="d-block pt-1">
                      {observation.site_notes || "-"}
                    </span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Field Notes{" "}
                    <span className="d-block pt-1">
                      {observation.field_note || "-"}
                    </span>
                  </li>
                </div>
              ))}
              <li className="col-12 mt-2">
                <hr></hr>
              </li>
              {/* Points Section */}
              <li className="col-12 mt-1">
                <span className="heading">SPCSP Points</span>
              </li>
              {soilData?.points.map((point, index) => (
                <div
                  key={point.globalid || index}
                  className="col-12 d-flex flex-wrap"
                >
                  <li className="col-6 col-md-4 col-lg-3">
                    Point ID{" "}
                    <span className="d-block pt-1">
                      {point.point_id || "-"}
                    </span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Latitude{" "}
                    <span className="d-block pt-1">
                      {point.latitude || "-"}
                    </span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Longitude{" "}
                    <span className="d-block pt-1">
                      {point.longitude || "-"}
                    </span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Treatment{" "}
                    <span className="d-block pt-1">
                      {point.treatment || "-"}
                    </span>
                  </li>
                </div>
              ))}
              <li className="col-12 mt-2">
                <hr></hr>
              </li>
              {/* Data BD Section */}
              <li className="col-12 mt-4">
                <span className="heading">SPCSP Data BD</span>
              </li>
              {soilData?.data_bd.map((bd, index) => (
                <div key={bd.fid || index} className="col-12 d-flex flex-wrap">
                  <li className="col-6 col-md-4 col-lg-3">
                    Project{" "}
                    <span className="d-block pt-1">{bd.project || "-"}</span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Point ID{" "}
                    <span className="d-block pt-1">{bd.point_id || "-"}</span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Test <span className="d-block pt-1">{bd.test || "-"}</span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Depth{" "}
                    <span className="d-block pt-1">{bd.depth || "-"}</span>
                  </li>
                  <li className="col-6 col-md-4 col-lg-3">
                    Volume (cm³){" "}
                    <span className="d-block pt-1">{bd.volume_cm3 || "-"}</span>
                  </li>
                </div>
              ))}
              <li className="col-12 mt-2"><hr></hr></li>
              {/* Data Sample Section */}
              <li className="col-12 mt-4">
                <span className="heading">Soil Sample Data</span>
              </li>
              <li className="col-12">
                <div className="tableBox">
                  <table>
                    <thead>
                      <tr>
                        <th>Lab Label</th>
                        <th>Farm ID</th>
                        <th>Group Code</th>
                        <th>Test Code</th>
                        <th>Project Code</th>
                        <th>pH</th>
                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {soilData?.data_sample.map((sample, index) => (
                        <tr key={sample.sampleid || index}>
                          <td>{sample.lablabel || "-"}</td>
                          <td>{sample.farmid || "-"}</td>
                          <td>{sample.sgroupcode || "-"}</td>
                          <td>{sample.testcode || "-"}</td>
                          <td>{sample.projectcode || "-"}</td>
                          <td>{sample.ph || "-"}</td>
                          <td>
                            <button
                              className="btn btn-link p-0"
                              onClick={() => handleOpenModal(sample)}
                            >
                              <span className="material-icons-outlined">
                                visibility
                              </span>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </li>
            </ul>

            <div className="pt-5 text-end">
              <NavLink to="/Soil">
                <button type="button" className="formBtn cancel">
                  Back to List
                </button>
              </NavLink>
            </div>
          </div>
        </section>
      </div>
      <Footer />
      <SampleDetailsModal
        isOpen={isModalOpen}
        sample={selectedSample}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export default SoilView;
